// Post-auth redirect helper. Only allows safe internal paths (no protocol / host).
export function nextParam() {
  try {
    const n = new URLSearchParams(window.location.search).get("next");
    if (n && n.startsWith("/") && !n.startsWith("//")) return n;
  } catch { /* ignore */ }
  return "";
}

export function nextDest(fallback = "/dashboard") {
  return nextParam() || fallback;
}
